/* eslint-disable jsx-a11y/anchor-is-valid */
import secondaryComponents from "../../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents, {
  BackButton,
} from "../../../../../../components/primaryComponents";
import {
  extractReadableDateOnly,
  formatCurrency,
} from "../../../../../../helpers";
// import { POExtra } from "../../../../../../components/secondaryComponents/PurchaseOrder";
import { Link, useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../../../routes/pathContants";
import {
  RoutedModal,
  WarningDialog,
} from "../../../../../../components/common";
import { useBillsDetails } from "./useBillsDetails";
import { EditIcon, WaybillIcon } from "../../../../../../assets/svgIcons";
import { useEditBills } from "../EditBills/useEditBills";
import {
  BillsExtra,
  BillsItemsTable,
} from "../../../../../../components/secondaryComponents/Bills";
import styles from "./styles.module.scss";
import { useState } from "react";
import { useQueryClient } from "react-query";
import { useStoreListObject } from "../../../../../../hooks/useStoreListObject";

export const BillsDetails = () => {
  const navigate = useNavigate();
  const { isLoading, billsDetails, billsItems, refetchBillDetails } =
    useEditBills({
      isEnabled: true,
    });
  const { isUpdatingStatus, views, setViews, handleApproveOrRejectBills } =
    useBillsDetails();
  const [isInvoice, setIsInvoice] = useState(null);
  const queryClient = useQueryClient();
  const { storeMap } = useStoreListObject();
  const currencyCode = storeMap?.[billsItems?.[0]?.store_id]?.currency_code;

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Bills Details"
      description="View the details of bill"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div>
            <BackButton />
          </div>

          <secondaryComponents.LoaderHelper
            classNames={"mt-5"}
            isLoading={isLoading}
          >
            <div>
              <div className={`${globalStyles.pageHeaders} mb-3`}>
                <div>
                  <h3 className="font-weight-normal">
                    <span className="gray--text">Bill Number: </span>
                    {billsDetails?.bill_number || "N/A"}
                  </h3>
                </div>
                <div
                  className="d-flex flex-wrap ml-auto"
                  style={{ gap: "10px" }}
                >
                  {billsDetails?.status === "IN_REVIEW" ? (
                    <>
                      <primaryComponents.Button
                        classNames={"btn btn--primary"}
                        style={{ width: "140px" }}
                        onClick={() => {
                          setViews((prev) => ({
                            ...prev,
                            isAcceptDialog: true,
                          }));
                        }}
                      >
                        Approve Bill
                      </primaryComponents.Button>
                      <primaryComponents.Button
                        classNames={"btn btn--outline-red "}
                        style={{ width: "140px" }}
                        onClick={() => {
                          setViews((prev) => ({
                            ...prev,
                            isRejectDialog: true,
                          }));
                        }}
                      >
                        Reject Bill
                      </primaryComponents.Button>
                    </>
                  ) : null}

                  {billsDetails?.status !== "APPROVED" ? (
                    <secondaryComponents.NavigateWithPermission
                      permissionParentKey={"Inventory Management"}
                      permissionChildKey={"can_create_or_update_bill"}
                    >
                      <primaryComponents.Button
                        classNames={"btn btn--outline"}
                        style={{ width: "140px" }}
                        onClick={() =>
                          navigate(
                            pathConstants.INVENTORY_BILLS_EDIT({
                              id: billsDetails?.id,
                            }),
                          )
                        }
                      >
                        Update Bill
                      </primaryComponents.Button>
                    </secondaryComponents.NavigateWithPermission>
                  ) : null}

                  <div className="ml-auto">
                    <BillsExtra
                      billsDetails={billsDetails}
                      showDownloadBtnFlat={billsDetails?.status === "APPROVED"}
                    />
                  </div>
                </div>
              </div>

              <div className={globalStyles.gridDetailsView}>
                <div>
                  <p className="dark--text">Status</p>
                  <p
                    className={`${globalStyles[billsDetails?.status === "IN_REVIEW" ? "statusBlock--pending" : billsDetails?.status === "APPROVED" ? "statusBlock--success" : billsDetails?.status === "REJECTED" ? "statusBlock--failed" : "statusBlock"]}`}
                  >
                    {billsDetails?.status?.replace("_", " ") || "N/A"}
                  </p>
                </div>

                <div>
                  <p className="dark--text">Payment Status</p>
                  <p
                    className={`${globalStyles[billsDetails?.payment_status === "PARTIALLY_PAID" ? "statusBlock--pending" : billsDetails?.payment_status === "PAID" ? "statusBlock--success" : "statusBlock--failed"]}`}
                  >
                    {billsDetails?.payment_status?.replace("_", " ") || "N/A"}
                  </p>
                </div>

                <div>
                  <p className="dark--text">Invoice Number</p>
                  {billsDetails?.invoice?.invoice_number ? (
                    <Link
                      to={pathConstants.INVENTORY_INVOICE_DETAILS({
                        id: billsDetails?.invoice?.id,
                      })}
                      className="purple--text smallest-text-size"
                    >
                      {billsDetails?.invoice?.invoice_number || "N/A"}
                    </Link>
                  ) : (
                    <p className="small-text-size">N/A</p>
                  )}
                </div>

                <div>
                  <p className="dark--text">Bill Amount</p>
                  <p className="small-text-size">
                    {formatCurrency({
                      value: billsDetails?.total,
                      currencyCode: currencyCode,
                    })}
                  </p>
                </div>

                <div>
                  <p className="dark--text">Amount Paid</p>
                  <p className="small-text-size">
                    {formatCurrency({
                      value: billsDetails?.amount_paid_to_supplier,
                      currencyCode: currencyCode,
                    })}
                  </p>
                </div>

                <div>
                  <p className="dark--text">Outstanding Amount</p>
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "10px" }}
                  >
                    <p
                      className={`small-text-size ${billsDetails?.outstanding_balance > 0 ? "error--text" : "success--text"}`}
                    >
                      {formatCurrency({
                        value: billsDetails?.outstanding_balance,
                        currencyCode: currencyCode,
                      })}
                    </p>

                    <secondaryComponents.ToolTipV2 tipText="Update Credit">
                      <span
                        className="mr-1"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setIsInvoice({
                            id: billsDetails?.invoice?.id,
                            outstanding_balance:
                              billsDetails?.outstanding_balance,
                            credit_amount: Number(billsDetails?.total || 0),
                            total_repayment:
                              billsDetails?.amount_paid_to_supplier,
                          })
                        }
                      >
                        <EditIcon />
                      </span>
                    </secondaryComponents.ToolTipV2>
                  </div>
                </div>

                <div>
                  <p className="dark--text">Invoice Amount</p>
                  <p className="small-text-size">
                    {formatCurrency({
                      value: billsDetails?.invoice_amount,
                      currencyCode: currencyCode,
                    })}
                  </p>
                </div>

                <div>
                  <p className="dark--text">Invoice Date</p>
                  <p className="small-text-size">
                    {billsDetails?.invoice_date
                      ? extractReadableDateOnly(billsDetails?.invoice_date)
                      : "N/A"}
                  </p>
                </div>
                <div>
                  <p className="dark--text">Invoice Due Date</p>
                  <p className="small-text-size">
                    {billsDetails?.invoice_due_date
                      ? extractReadableDateOnly(billsDetails?.invoice_due_date)
                      : "N/A"}
                  </p>
                </div>
                <div>
                  <p className="dark--text">Suppier</p>

                  <Link
                    to={pathConstants.INVENTORY_SUPPLIERS_DETAILS({
                      id: billsDetails?.supplier?.id,
                    })}
                    className="purple--text small-text-size"
                  >
                    {billsDetails?.supplier?.name || "N/A"}
                  </Link>
                </div>

                <div>
                  <p className="dark--text">PO Number</p>
                  <Link
                    to={pathConstants.INVENTORY_PURCHASE_ORDER_DETAILS({
                      id: billsDetails?.purchase_order?.id,
                    })}
                    className="small-text-size purple--text cursor-pointer"
                  >
                    {billsDetails?.purchase_order?.po_number || "N/A"}
                  </Link>
                </div>
                <div>
                  <p>GRN Number</p>
                  {billsDetails?.goods_received?.length > 0 ? (
                    <>
                      {billsDetails?.goods_received?.map((item) => (
                        <>
                          <Link
                            key={item?.id}
                            to={pathConstants.INVENTORY_GOODS_RECEIVED_DETAILS({
                              id: item?.id,
                            })}
                            className="small-text-size purple--text"
                          >
                            {item?.gr_number || "N/A"}
                          </Link>
                          {", "}
                        </>
                      ))}
                    </>
                  ) : (
                    <p className="small-text-size">N/A</p>
                  )}
                </div>

                <div>
                  <p className="dark--text">Store</p>
                  <p className="small-text-size">
                    {billsDetails?.stores
                      ?.map((store) => store?.name)
                      ?.join(", ")}
                  </p>
                </div>

                <div>
                  <p className="dark--text">Created by</p>
                  <p className="small-text-size">
                    {billsDetails?.initiated_by?.first_name || "N/A"}
                  </p>
                </div>

                <div>
                  <p className="dark--text">Approved By</p>
                  <p className="small-text-size">
                    {billsDetails?.approved_by?.first_name || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="dark--text">Rejected By</p>
                  <p className="small-text-size">
                    {billsDetails?.rejected_by?.first_name || "N/A"}
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h5>Order Items</h5>

              <div
                className={`${globalStyles.cardWithBackground} white`}
                style={{ gap: "30px" }}
              >
                <BillsItemsTable
                  billsItems={billsItems}
                  billsDetails={billsDetails}
                />

                <div
                  className="d-flex flex-column flex-md-row w-100"
                  style={{ gap: "15px" }}
                >
                  <div
                    className={`${globalStyles.cardWithBorder} white w-100 pb-0`}
                    style={{ gap: "20px" }}
                  >
                    <h5 className="font-weight-normal">Price Summary</h5>

                    <div className="d-flex justify-content-between">
                      <p>Subtotal:</p>
                      <h6 className="font-weight-normal">
                        {formatCurrency({
                          value: billsDetails?.sub_total,
                          currencyCode: currencyCode,
                        })}
                      </h6>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <p>Discount:</p>
                      <h6 className="font-weight-normal">
                        {formatCurrency({
                          value: billsDetails?.discount_amount,
                          currencyCode: currencyCode,
                        })}
                      </h6>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <p>VAT: </p>
                      <h6 className="font-weight-normal">
                        {billsDetails?.vat_rate || 0}%
                      </h6>
                    </div>
                    <div className={`${styles.priceSection} mt-auto`}>
                      <p>Total</p>
                      <h5>
                        {formatCurrency({
                          value: billsDetails?.total,
                          currencyCode: currencyCode,
                        })}
                      </h5>
                    </div>
                  </div>

                  <div
                    className={`${globalStyles.cardWithBorder} white w-100 pb-0`}
                    style={{ gap: "20px" }}
                  >
                    <h5 className="font-weight-normal">Payment Summary</h5>

                    <div className="d-flex justify-content-between align-items-center">
                      <p>Amount Paid to Supplier:</p>{" "}
                      <h6 className="font-weight-normal">
                        {formatCurrency({
                          value: billsDetails?.amount_paid_to_supplier,
                          currencyCode: currencyCode,
                        })}
                      </h6>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                      <p>Payment Method:</p>

                      <h6 className="font-weight-normal">
                        {billsDetails?.payment_method}
                      </h6>
                    </div>

                    {/* <div className="d-flex justify-content-between align-items-center">
                      <p>Account:</p>
                      <h6 className="font-weight-normal">
                        {billsDetails?.account || "N/A"}
                      </h6>
                    </div> */}

                    <div className={`${styles.priceSection} mt-auto`}>
                      <p>Outstanding</p>
                      <h5
                        className={`${billsDetails?.outstanding_balance > 0 ? "error--text" : "success--text"}`}
                      >
                        {formatCurrency({
                          value: billsDetails?.outstanding_balance || 0,
                          currencyCode: currencyCode,
                        })}
                      </h5>
                    </div>
                  </div>
                </div>

                {/* <div className={`${globalStyles.cardWithBorder} white`}>
                  <div className={`${styles.header} mb-3 align-items-center`}>
                    <div className="w-50">
                      <h6 className="mb-1 font-weight-bold">Bank Account</h6>
                      <p>
                        Select one or more banks to record a bank transfer
                        transaction
                      </p>
                    </div>
                    <div className="w-50">
                      <primaryComponents.MultipleSelectField
                        name="account"
                        nameKey="label"
                        idKey="value"
                        value={
                          billsDetails?.bill_ledger_account?.map((item) => ({
                            label: item?.ledger_account?.account_name,
                            value: item?.ledger_account?.id,
                          })) || []
                        }
                        isDisabled
                        classNames="account-select"
                        giveControl={false}
                      />
                    </div>
                  </div>
                  <div className={`${globalStyles.cardWithBorder} pb-0`}>
                    {billsDetails?.bill_ledger_account?.length > 0 ? (
                      billsDetails?.bill_ledger_account?.map((item) => {
                        const account = item?.ledger_account;

                        return (
                          <div
                            key={account?.id}
                            className="d-flex justify-content-between align-items-center mb-3"
                          >
                            <div className="w-50">
                              {account.account_name} -{" "}
                              {account.bank_name ? account.bank_name : ""} (
                              {formatCurrency({
                                value: account.balance,
                                currencyCode: currencyCode,
                              })}
                              )
                            </div>

                            <primaryComponents.AmountField
                              placeholder="Enter amount"
                              coverClassNames={`${styles.inputField}`}
                              value={item.amount || ""}
                              floatError={false}
                              currency_code={currencyCode}
                              isDisabled
                            />
                          </div>
                        );
                      })
                    ) : (
                      <p className="mb-3 text-center">
                        No bank account selected.
                      </p>
                    )}
                  </div>
                </div> */}

                <div>
                  <h4 className="font-weight-normal mb-3">
                    Additional Details
                  </h4>
                  <div
                    className={"d-flex flex-column flex-md-row"}
                    style={{ gap: "15px" }}
                  >
                    <div
                      className={`d-flex flex-column w-100 ${globalStyles.cardWithBorder}`}
                      style={{ gap: "25px" }}
                    >
                      <h6 className="gray--text ">Shipping Details</h6>
                      <div>
                        <p className="small-text-size">Account Name</p>
                        <h5 className="font-weight-semibold">
                          {billsDetails?.account_name || "N/A"}
                        </h5>
                      </div>
                      <div>
                        <p className="small-text-size">Account Number</p>
                        <h5 className="font-weight-semibold">
                          {billsDetails?.account_number || "N/A"}
                        </h5>
                      </div>
                      <div>
                        <p className="small-text-size">Bank Name</p>
                        <h5 className="font-weight-semibold">
                          {billsDetails?.bank_name || "N/A"}
                        </h5>
                      </div>
                    </div>

                    <div className={`w-100 ${globalStyles.cardWithBorder}`}>
                      <p>Invoice Proof </p>
                      {billsDetails?.invoice_urls?.length ? (
                        <>
                          {billsDetails?.invoice_urls.map((url, index) => (
                            <div key={index}>
                              <primaryComponents.Button
                                classNames={"btn btn--outline"}
                                onClick={() => window.open(url)}
                                style={{ width: "200px", height: "40px" }}
                              >
                                <WaybillIcon className="mr-2" />
                                View Invoice {index + 1}
                              </primaryComponents.Button>
                            </div>
                          ))}
                        </>
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </secondaryComponents.LoaderHelper>

          {/* Approve Modal */}
          <secondaryComponents.Modal
            isActive={views?.isAcceptDialog}
            closeModal={() =>
              setViews((prev) => ({ ...prev, isAcceptDialog: false }))
            }
            width={500}
          >
            <WarningDialog
              title={`Approve Bill: ${billsDetails?.bill_number}`}
              btnClassNames="btn--primary"
              closeModal={() =>
                setViews((prev) => ({ ...prev, isAcceptDialog: false }))
              }
              handler={() =>
                handleApproveOrRejectBills(billsDetails?.id, "APPROVED")
              }
              isLoading={isUpdatingStatus}
            >
              <p>
                Supplier:{" "}
                <span className="dark--text">
                  {billsDetails?.supplier?.name}
                </span>
              </p>
              <p>
                Bills Date:{" "}
                <span className="dark--text">
                  {billsDetails?.gr_date
                    ? extractReadableDateOnly(billsDetails?.gr_date)
                    : "N/A"}
                </span>
              </p>
            </WarningDialog>
          </secondaryComponents.Modal>

          {/* Reject Modal */}
          <secondaryComponents.Modal
            isActive={views?.isRejectDialog}
            closeModal={() =>
              setViews((prev) => ({ ...prev, isRejectDialog: false }))
            }
            width={500}
          >
            <WarningDialog
              title={`Reject Bill: ${billsDetails?.bill_number}`}
              closeModal={() =>
                setViews((prev) => ({ ...prev, isRejectDialog: false }))
              }
              handler={() =>
                handleApproveOrRejectBills(billsDetails?.id, "REJECTED")
              }
              isLoading={isUpdatingStatus}
            >
              <p>
                Supplier:{" "}
                <span className="dark--text">
                  {billsDetails?.supplier?.name}
                </span>
              </p>
              <p>
                Bills Date:{" "}
                <span className="dark--text">
                  {billsDetails?.gr_date
                    ? extractReadableDateOnly(billsDetails?.gr_date)
                    : "N/A"}
                </span>
              </p>
            </WarningDialog>
          </secondaryComponents.Modal>

          <RoutedModal
            isActive={isInvoice !== null}
            closeModal={() => setIsInvoice(null)}
            headerTitle="Update Invoice Credit"
            width={650}
            style={{ height: "auto" }}
          >
            <secondaryComponents.CreditForm
              currencyCode={currencyCode}
              invoiceDetails={isInvoice}
              billsDetails={billsDetails}
              supplierDetails={billsDetails?.supplier}
              handleFetchInvoice={() => {
                refetchBillDetails();
                queryClient.invalidateQueries(["getBills"]);
              }}
              closeWidget={() => setIsInvoice(null)}
            />
          </RoutedModal>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
